<template>
  <div id="app">
    <!-- <Spin /> -->
    <Header />
    <router-view class="main" />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Layout/Header'
import Footer from '@/components/Layout/Footer'

import { mapActions } from 'vuex'

export default {
  components: { Header, Footer },
  created() {
    this.initialize()
    window.addEventListener('resize', this.detectWindowWidth)
    this.getUserInfo()
  },
  destroyed() {
    window.removeEventListener('resize', this.detectWindowWidth)
  },
  methods: {
    ...mapActions(['getUserInfo', 'setWindowWidth']),
    initialize() {
      this.detectWindowWidth()
    },
    detectWindowWidth() {
      this.setWindowWidth(window.innerWidth)
    }
  }
}
</script>

<style lang="scss">
@import './style/main.scss';

#app {
  position: relative;
}
.main {
  min-height: calc(100vh - 330px);
  @include minWidth992 {
    min-height: calc(100vh - 290px);
  }
}
</style>
